











































































import Vue from "vue";

//Components
import SecurityConfigurationCard from "./SecurityConfigurationCard.vue";
import StocksConfigurationDetail from "@/views/App/SecurityAndConfiguration/StocksConfiguration/StocksConfigurationDetail.vue";

//Model
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { RollProfile } from "@/model/data/security/InstallationStocksConfiguration";

export default Vue.extend({
    components: { SecurityConfigurationCard, StocksConfigurationDetail },
    props: {
        importableTemplates: Array,
        showDialog: { type: Boolean, required: true },
        loading: Boolean,
        fromStocksConfig: { type: Boolean, default: false },
        rollsProfile: { type: RollProfile },
    },
    data() {
        return {
            selectedTemplate: 0,
        };
    },
    computed: {
        showImportTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog");
            },
        },
        importableTemplatesItems() {
            let items = [];
            if (this.importableTemplates && this.importableTemplates.length) {
                for (let i = 0; i < this.importableTemplates.length; i++) {
                    items.push({ value: i, text: this.importableTemplates[i].name });
                }
            }
            return items;
        },
    },
    methods: {
        importConfiguration() {
            this.$emit("import-configuration", this.importableTemplates[this.selectedTemplate].id, this.importableTemplates[this.selectedTemplate].name);
        },
        templateContentToString(templateContent: TemplateContentEnum) {
            let templateContentString = "";
            if ((templateContent & TemplateContentEnum.Delays) != TemplateContentEnum.None) templateContentString += this.$t("security_management.delays") + ", ";
            if ((templateContent & TemplateContentEnum.Alarms) != TemplateContentEnum.None) templateContentString += this.$t("security_management.alarms") + ", ";
            if ((templateContent & TemplateContentEnum.TimeBands) != TemplateContentEnum.None) templateContentString += this.$t("security_management.timeBands") + ", ";
            if (templateContentString) return templateContentString.substring(0, templateContentString.length - 2);
            return templateContentString;
        },
    },
});
